import DOMPurify from "dompurify";

function sanitize(value) {
  return DOMPurify.sanitize(value ?? "", { USE_PROFILES: { html: true } });
}

export const safeHtml = {
  bind(el, binding) {
    el.innerHTML = sanitize(binding.value);
  },
  update(el, binding) {
    if (binding.value === binding.oldValue) return;
    el.innerHTML = sanitize(binding.value);
  },
};
